export const CONTEXTUAL_TOOLS_POC = 'contextual-tools';

export default {
  key: CONTEXTUAL_TOOLS_POC,
  name: 'Contextual tools panel',
  description:
    "Open staff tools in a side panel next to the record you're on. While it's on, Staff is read-only in this browser.",
  // The read-only network guard installs at startup (index.jsx), so the page reloads on change
  reloadOnChange: true
};
